import React from "react";
import { Button, Modal } from "react-bootstrap";
import classes from "./ticketGenerator.module.css";

const TrainTicketPreview = ({ show, html, onClose, onEdit, onSave, onPrint, onDownload, saving }) => {
  const handlePrint = () => {
    const win = window.open("", "_blank");
    win.document.write(html);
    win.document.close();
    win.focus();
    win.print();
  };

  return (
    <Modal show={show} onHide={onClose} size="xl" dialogClassName={classes.PreviewModal}>
      <Modal.Header closeButton>
        <Modal.Title>Ticket Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={classes.PreviewFrame} dangerouslySetInnerHTML={{ __html: html }} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onEdit}>Edit</Button>
        <Button variant="info" onClick={handlePrint}>Print</Button>
        <Button variant="primary" onClick={onDownload}>Download PDF</Button>
        <Button variant="success" onClick={onSave} disabled={saving}>
          {saving ? "Saving..." : "Save Ticket"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TrainTicketPreview;
